import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import WarehousePrices from "../warehouse/WarehousePrices";
import OfferCollection from "../offer/OfferCollection";
import CountryStateCollection from "../countryState/CountryStateCollection";
import JsonMappedModel from "../helpers/JsonMappedModel";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Country extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Country.id_attribute_name]: null,
      [Country.states_attribute_name]: CountryStateCollection,
      [Country.code_attribute_name]: null,
      [Country.currency_name_attribute_name]: null,
      [Country.currency_code_attribute_name]: null,
      [Country.currency_symbol_attribute_name]: null,
      [Country.name_attribute_name]: null,
      [Country.phone_code_attribute_name]: null,
      [Country.warehouse_prices_attribute_name]: WarehousePrices,
      [Country.offers_attribute_name]: OfferCollection,
      [Country.emoji_attribute_name]: null,
      [Country.i18n_attribute_name]: null,
      [Country.currency_id_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getCurrencyIdAttributeName() {
    return this.currency_id_attribute_name;
  }
  static getCurrencyAttributeName() {
    return this.currency_attribute_name;
  }
  getCurrencyId() {
    return this.getAttribute(Country.getCurrencyIdAttributeName());
  }
  getId() {
    return this.getAttribute(Country.id_attribute_name);
  }
  getName() {
    return this.getAttribute(Country.name_attribute_name);
  }
  getEmoji() {
    return this.getAttribute(Country.emoji_attribute_name);
  }
  getCountryId() {
    return this.getAttribute(Country.id_attribute_name);
  }
  getCode() {
    return this.getAttribute(Country.code_attribute_name);
  }
  getCountryFlag() {
    return this.getAttribute(Country.emoji_attribute_name);
  }
  getCurrencySymbol() {
    return this.getAttribute(Country.currency_symbol_attribute_name);
  }
  getCurrencyCode() {
    return this.getAttribute(Country.currency_code_attribute_name);
  }
  getI18nNames() {
    return this.getAttribute(Country.i18n_attribute_name);
  }
  getCountryTranslation(lang) {
    var _lang$split$, _lang$split, _this$getI18nNames$la, _this$getI18nNames;
    let langSplit = (_lang$split$ = lang === null || lang === void 0 || (_lang$split = lang.split) === null || _lang$split === void 0 || (_lang$split = _lang$split.call(lang, '-')) === null || _lang$split === void 0 ? void 0 : _lang$split[0]) !== null && _lang$split$ !== void 0 ? _lang$split$ : 'en';
    return (_this$getI18nNames$la = (_this$getI18nNames = this.getI18nNames()) === null || _this$getI18nNames === void 0 || (_this$getI18nNames = _this$getI18nNames[langSplit]) === null || _this$getI18nNames === void 0 ? void 0 : _this$getI18nNames['country_i18n_name']) !== null && _this$getI18nNames$la !== void 0 ? _this$getI18nNames$la : this.getName();
  }
  getNameTranslation(lang) {
    return this.getCountryTranslation(lang);
  }
  getNameTranslationWithEmoji(lang) {
    return [this.getEmoji(), this.getCountryTranslation(lang)].join(' &nbsp; ');
  }
  getCountryPhoneCode() {
    return this.getAttribute(Country.phone_code_attribute_name);
  }
  getPhoneCode() {
    return this.getAttribute(Country.phone_code_attribute_name);
  }
  getCountrySelectObject(text = 'text', value = 'value', otherFields = [], local = 'en') {
    let item = {
      [text !== null && text !== void 0 ? text : 'text']: this.getCountryTranslation(local),
      [value !== null && value !== void 0 ? value : 'value']: this.getId()
    };
    if (otherFields.includes('emoji')) item.emoji = this.getEmoji();
    if (otherFields.includes('country')) item.country = this;
    return item;
  }
  static getIdAttributeName() {
    return Country.id_attribute_name;
  }
  static getNameAttributeName() {
    return Country.name_attribute_name;
  }
  static getListValueKey() {
    return this.getIdAttributeName();
  }
  static getListTextKey() {
    return this.getNameAttributeName();
  }
}
_defineProperty(Country, "id_attribute_name", 'country_id');
_defineProperty(Country, "states_attribute_name", 'country_country_state');
_defineProperty(Country, "code_attribute_name", 'country_code');
_defineProperty(Country, "currency_name_attribute_name", 'country_currency_name');
_defineProperty(Country, "currency_code_attribute_name", 'country_currency_code');
_defineProperty(Country, "currency_symbol_attribute_name", 'country_currency_symbol');
_defineProperty(Country, "name_attribute_name", 'country_name');
_defineProperty(Country, "phone_code_attribute_name", 'country_phone_code');
_defineProperty(Country, "warehouse_prices_attribute_name", 'country_warehouse_prices');
_defineProperty(Country, "offers_attribute_name", 'country_offers');
_defineProperty(Country, "emoji_attribute_name", 'country_emoji');
_defineProperty(Country, "i18n_attribute_name", 'country_i18n');
_defineProperty(Country, "currency_id_attribute_name", 'currency_id');
_defineProperty(Country, "currency_attribute_name", 'currency');